<template>
  <div class="section-header">
    <div class="section-header__left">
      <slot name="back"></slot>
      <h3 class="section-header__title">{{ title }}</h3>
    </div>
    <div class="section-header__actions">
      <slot></slot>

      <c-button-help
        v-if="helpDocId"
        :link="helpDocId"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    helpDocId: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}

.section-header__left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.section-header__title {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  line-height: 1.2;
}

.section-header__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

/* Мобільна версія */
@media (max-width: 576px) {
  .section-header {
    gap: 16px;
  }

  .section-header__left {
    flex: 1 1 100%;
  }

  .section-header__title {
    font-size: 18px;
  }

  .section-header__actions {
    flex: 1 1 100%;
    justify-content: flex-end;
  }
}

:deep(.btn) {
  margin: 0 !important;
}
</style>
